
import Themeable from 'vuetify/lib/mixins/themeable';
import { Component, Vue } from 'vue-property-decorator';
import { ServerInterface, ServerRepositoryInterface } from '@/services/Server/Interfaces';
import { DataTableHeader } from 'vuetify';
import { ServerStatus } from '@/services/Server';
import { AxiosError } from 'axios';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'serverRepository',
  ],
})
export default class ViewServer extends Vue {
  public loading: boolean = true;
  public readonly serverRepository!: ServerRepositoryInterface;
  public server: ServerInterface = {} as ServerInterface;
  public serverStatuses: DataTableHeader[] = [
    { text: 'UP', value: 'Up' },
    { text: 'DOWN', value: 'Down' },
  ];

  public async mounted(): Promise<void> {
    await this.initialize();
  }

  public async initialize(): Promise<void> {
    try {
      this.server = await this.serverRepository.getServer(this.$route.params.server);
      this.loading = false;
    } catch (e) {
      this.$errorDialog.show((e as AxiosError)?.response?.data?.message || (e as Error).message);
    }
  }

  public async changeServerStatus(status: string): Promise<void> {
    if (status !== this.server.status) {
      try {
        await this.serverRepository.updateServerStatus(this.server.hostname, status);
        this.server.status = status === 'Up' ? ServerStatus.Up : ServerStatus.Down;
        this.$successDialog.show('Server Status Updated!');
      } catch (e) {
        this.$errorDialog.show((e as AxiosError)?.response?.data?.message || (e as Error).message);
      }
    }
  }
}
